import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { updateProjectSetting } from 'features/project';
import { clearExistingEquipmentForNoAnswer } from 'features/structure';
import { HAS_EXISTING_EQUIPMENT_NO } from './existing-equipment-page-visibility';

export const REMOVE_EXISTING_EQUIPMENT_CONFIRM_TITLE =
  'Remove existing equipment?';

export const REMOVE_EXISTING_EQUIPMENT_CONFIRM_MESSAGE =
  'This will delete all of the existing equipment you have entered.';

export const REMOVE_EXISTING_EQUIPMENT_CONFIRM_BUTTON = 'Remove Equipment';

export const REMOVE_EXISTING_EQUIPMENT_CANCEL_BUTTON = 'Keep Current Answer';

export function applyNoExistingEquipmentAnswer(
  dispatch: Dispatch<UnknownAction>
): void {
  dispatch(clearExistingEquipmentForNoAnswer());
  dispatch(
    updateProjectSetting({
      attributeCode: 'project_type',
      value: HAS_EXISTING_EQUIPMENT_NO
    })
  );
}
